module.exports = __webpack_public_path__ + "static/media/operation.30fd4f40.jpg";